import RichText from '@eneco/components/RichText/RichText';
import { Image } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';

export const ThankYouCard = () => {
  const { fields } = useContent<DashboardOverviewRendering>();
  const card = fields.thankYouCard;

  if (!card) {
    return null;
  }

  const image = card.image?.value?.formats[0];

  return (
    <StyledDashboardBlock>
      {card.description?.value && <RichText html={card.description.value} />}
      {image && <Image src={image.src} alt={card.image.value.alt ?? ''} />}
    </StyledDashboardBlock>
  );
};
